import { createContext } from 'react';
import { IAuthenticationContext } from './types';

const AuthenticationContext = createContext<IAuthenticationContext | undefined>(
  undefined,
);

export default AuthenticationContext;
